















import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import PlanResultItem from './PlanEdtiResultItem.vue';
import PlanEditResultMixin from '@/mixins/plan/edit/PlanEditResultMixin';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import PlanEditModel from '@/models/PlanEditModel';
import DefaultConfig from '@/configs/PlanEditResultConfig';
import {cloneDeep, isEqual} from 'lodash';
import {PlanEditResultCurrentConfig} from '@/models/PlanEditResultModel';

@Component({
    name: 'PlanEditResult.vue',
    components: {
        PlanResultItem,
    },
    computed: {
        ...mapState('planEdit', ['planEdit', 'planCalculationCount']),
        ...mapState('planEditResult', ['loading', 'currentConfig']),
        ...mapGetters('planEditResult', ['hasOwnConfig']),
    },
    methods: {
        ...mapActions('planEditResult', ['init']),
        ...mapMutations('planEdit', ['increasePlanCalculationCount']),
    },
})
export default class PlanEditResult extends Mixins(PlanEditResultMixin) {
    @Prop() isEdit!: boolean;

    public planEdit!: PlanEditModel;
    public loading!: boolean;
    public init!: Function;
    public hasOwnConfig!: boolean;
    public currentConfig!: PlanEditResultCurrentConfig | null;
    public planCalculationCount!: number;
    public increasePlanCalculationCount!: Function;

    private routePath: string = '';
    private defaultConfig = DefaultConfig;

    get tabData() {
        return {
            idPlanRes: this.result?.Id,
        };
    }

    get config() {
        if (this.hasOwnConfig && this.currentConfig?.Value) {
            return JSON.parse(this.currentConfig.Value);
        } else {
            return cloneDeep(this.defaultConfig);
        }
    }

    get key() {
        return `${this.currentConfig?.Id}${this.planCalculationCount}`;
    }

    @Watch('config', {deep: true})
    onConfigChange(value: any, oldValue: any) {
        if (this.result && !isEqual(value, oldValue)) this.increasePlanCalculationCount();
    }

    created() {
        this.routePath = this.getRoutePath();
        this.init(this.planEdit.IdLastPlanRes);
    }

    async activated() {
        if (this.routePath)
            this.$router
                .replace({
                    path: this.$route.path.replace(/(?<=result).*/, this.routePath),
                })
                .catch(() => {});
    }

    getRoutePath() {
        return this.$route.path.replace(/^.*result/gi, '');
    }

    onUpdateRoute(route: string) {
        this.routePath = route;
        this.$router
            .replace({
                path: this.$route.path.replace(/(?<=result).*/, route),
            })
            .catch(() => {});
    }
}
